exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ecobalyse-ingredients-selects[data-v-af6de68a] {\n    display: contents;\n}\n", ""]);

// exports
